// @ts-check
/* eslint-env browser */
import { reactiveStore } from '../../../reactive-store.js'

export class OpacitySlider extends HTMLElement {
  connectedCallback () {
    this.input = /** @type {HTMLInputElement | null} */ (this.querySelector('input[type="range"]'))
    this.input?.addEventListener('input', this.#update)
    this.#update()
  }

  #update = () => {
    const valueEl = this.querySelector('.opacity-slider__value')
    if (!valueEl || !this.input) return

    valueEl.textContent = `${this.input.value}%`

    const opacity = Number(this.input.value) / 100
    const current = reactiveStore.overlayMaps.get()

    reactiveStore.overlayMaps.set(
      current.map((entry) => {
        if (entry.storagePath === this.dataset.storagePath) {
          return { ...entry, opacity }
        }
        return entry
      })
    )
  }
}

customElements.define('opacity-slider', OpacitySlider)
